import { z } from 'zod';
/**
 * Corps de `POST /company`. Les champs sont ceux du formulaire backoffice, qui
 * envoie toujours les quatre clés (`logoId` à `null` quand aucun logo n'est
 * choisi) : on se contente donc de fixer les types et des bornes hautes larges.
 */
export const createCompanySchema = z.object({
    logoId: z.string().max(255).nullable(),
    name: z.string().min(1).max(255),
    country: z.string().min(1).max(255),
    iataCode: z.string().min(1).max(16),
});
/** Corps de `PUT /company` : la création + l'id et le drapeau de changement de logo. */
export const updateCompanySchema = createCompanySchema.extend({
    id: z.string().min(1),
    shouldChangeLogo: z.boolean(),
});
